.highlighted {
  animation-duration: 1s;
  animation-name: highlighted;
  animation-timing-function: cubic-bezier(0.24, 0.91, 0.01, 0.99);
}

@keyframes highlighted {
  50% {
	filter: brightness(0.8) saturate(1.1);
  }
}

.noMessages {
  @include themify($themes) {
	color: themed("neutral-primary");
  }
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  user-select: none;
  white-space: normal;
  word-break: break-word;
  height: 100%;
}

.messageRowContainer {
  display: flex;
  align-items: center;
  position: relative;
}

.messageOutContainer > div {
  padding-left: 36px;
}

.messageInContainer > div {
  padding-right: 36px;
}

.messageInternalContainer > div {
  padding-left: 36px;
  padding-right: 36px;
}

.deleteCheckBox {
  margin-right: 29px;
  
  & > div {
	min-width: 20px;
  }
}

.messageDateContainer {
  position: sticky;
  z-index: 1;
  top: 0;
  display: flex;
  align-content: center;
  justify-content: center;
  pointer-events: none;
}

.messageDate {
  @include themify($themes) {
	background-color: themed("main-secondary");
	box-shadow: 0 1px 1px themed("shadow");
	color: themed("main-primary");
  }
  display: flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
  padding: 6px;
  margin: 6px 0;
  
  border-radius: 8px;
  font-size: 12px;
}

.elementsList {
  padding: 24px;
}

.listHeader {
  padding-top: 12px;
}

.listFooter {
  padding-bottom: 12px;
}
